import { z } from 'zod';

import { databaseEntryValidator } from './validators.ts';

export const addEntrySchema = z.object({
  entry: databaseEntryValidator,
  index: z
    .number()
    .int('Index must be an integer')
    .nonnegative('Index cannot be negative')
    .optional()
});

export const removeEntrySchema = z.object({
  entryId: z.string().min(1, 'entryId is required')
});

export const reorderEntriesSchema = z.object({
  entryIds: z.array(z.string().min(1)).min(1, 'At least one entryId is required'),
  newIndex: z
    .number()
    .int('newIndex must be an integer')
    .nonnegative('newIndex cannot be negative')
});

export type AddEntryInput = z.infer<typeof addEntrySchema>;
export type RemoveEntryInput = z.infer<typeof removeEntrySchema>;
export type ReorderEntriesInput = z.infer<typeof reorderEntriesSchema>;
